<template>
  <div class="d-flex align-center justify-space-between" data-testid="project-header">
    <div class="">
      <div class="d-flex">
        <p class="mb-1" data-testid="project-header__breadcrumb-home">Home</p>
        <p class="px-2 mb-1" data-testid="project-header__breadcrumb-separator">/</p>
        <p class="mb-1" data-testid="project-header__breadcrumb-description">{{ description }}</p>
      </div>
      <div class="d-flex align-center">
        <h3 class="black--text font-weight-medium">Information Manager</h3>
        <v-tooltip bottom content-class="tooltip-bottom">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              data-testid="project-header__refresh-btn"
              v-bind="attrs"
              v-on="on"
              class="shadow-off ml-1"
              icon
              @click="$emit('refresh')"
            >
              <v-icon size="24" data-testid="project-header__refresh-icon">mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>

          <activity-log 
          :resource-id="cycleId"
          data-testid="financialclose-project-header__activitylog"
          row-description="Information Manager" 
          :type="ACTIVITY_LOG_TYPES.TASKLIST_IM"
          />
      </div>
    </div>
    <div class="d-flex">
      <lb-file
        v-model="localFile"
        label=""
        class="py-0 my-0 mr-2"
        style="height: 2.5rem;"
        data-testid="project-header__bulk-upload-file"
        :loading="fileLoading"
        v-if="canEdit"
        :drag="false"
        hidedetails
        @change="handleFileChange"
        :displayname="false"
        accept=".xlsx,.xls,.csv"
      />
      <v-btn
        class="ml-1 secondaryBtn mr-3"
        @click="$emit('download-template')"
        data-testid="project-header__download-template-btn"
      >
        <span>Download Template</span>
      </v-btn>
      <v-btn
        class="secondaryBtn mr-3"
        v-if="hasRequests"
        @click="$emit('download-all')"
        data-testid="project-header__download-all-btn"
      >
        <v-icon data-testid="project-header__download-all-icon">mdi-download</v-icon>
        <span>Download All</span>
      </v-btn>
      <v-btn
        color="primary"
        class="mr-1 white--text"
        v-if="canAddRequest"
        @click="$emit('new-request')"
        data-testid="project-header__new-request-btn"
      >
        <v-icon class="mr-1" data-testid="project-header__new-request-icon">mdi-plus</v-icon>
        <span data-testid="project-header__new-request-label">New Request</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { ACTIVITY_LOG_TYPES } from "../../../../utils/constants";
import ActivityLog from "../../../../components/ActivityLog/ActivityLog.vue";
export default {
  name: 'ProjectHeader',
  components: {
   ActivityLog
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    fileLoading: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    hasRequests: {
      type: Boolean,
      default: false,
    },
    canAddRequest: {
      type: Boolean,
      default: false,
    },
    file: {
      type: [File, Object],
      default: null,
    },
    cycleId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localFile: null,
    };
  },
  computed: {
    ACTIVITY_LOG_TYPES() {
      return ACTIVITY_LOG_TYPES;
    },
  },
  watch: {
    file(newVal) {
      this.localFile = newVal;
    },
  },
  methods: {
    handleFileChange() {
      this.$emit('file-change', this.localFile);
    },
    
  },
};
</script>

<style lang="scss" scoped>
[data-testid="project-header"] {
  padding-bottom: 12px;
}
</style>
